import { GlowShadow } from '../../Components/GlowShadow'
import { useNavigate } from "react-router-dom";
import img1 from '../../Assets/case_1.png'
import img2 from '../../Assets/case_2.png'
import img3 from '../../Assets/case_3.png'
import img4 from '../../Assets/case_4.png'
import * as S from './styles'

export const CASES = [
  {
    slug: "icc",
    title: "Tablet 3D",
    img: img1,
    alt: "Mock de tablet 3D"
  },
  {
    slug: "surf-center",
    title: "E-commerce Fashion",
    img: img2,
    alt: "E-commerce em laptop"
  },
  {
    slug: "ecosalva",
    title: "Deliver Excellence",
    img: img3,
    alt: "Landing azul"
  },
  {
    slug: "agroflow",
    title: "App Dashboard",
    img: img4,
    alt: "Dashboard em notebook"
  },

];

export const Cases = () => {
  const navigate = useNavigate();

  return (
    <S.Wrapper>
      <h2>
        Histórias reais de inovação, eficiência e transformação digital.
      </h2>
      <div style={{ position: 'relative', height: '53px', marginBottom: '48px' }}>
        <GlowShadow />
      </div>

      <S.CardBox>
        {CASES.map((c) => (
          <S.CardButton
            key={c.slug}
            type="button"
            aria-label={`Abrir case: ${c.title}`}
            onClick={() => navigate(`/cases/${c.slug}`)}
            $bg={c.img}
          >
          </S.CardButton>
        ))}
      </S.CardBox>
    </S.Wrapper>
  )
}
